import React, { FC } from 'react';
import findIndex from 'lodash/findIndex';
import { ButtonGroup, GroupButton } from '../common/ButtonGroup';
import { HelpTooltip } from '../common/HelpTooltip';
import { comparePriceTier, getPriceTierLevelLabel, PriceTier, serializePriceTier } from '../../../models/PriceTier';
import { Trans, useTranslation } from 'react-i18next';

const priceTiers: PriceTier[] = [
    { lendingModel: 'OCOU', level: 'MIN' },
    { lendingModel: 'SIM', level: 'MIN' },
    { lendingModel: 'SIM', level: 'MEDIUM' },
    { lendingModel: 'SIM', level: 'MAX' }
];

export const PriceSelectorHelpTooltip = () => {
    return (
        <HelpTooltip size="large">
            <Trans i18nKey={'shop.tooltips.priceSelectorTooltip'} components={[<p />, <div />]} />
        </HelpTooltip>
    );
};

type Props = {
    readonly value: PriceTier;
    readonly onChange: (priceTier: PriceTier) => void;
};

export const PriceSelector: FC<Props> = ({ value, onChange }) => {
    const selectedIndex = findIndex(priceTiers, (item: PriceTier) => comparePriceTier(item, value)) + 1;
    const { t } = useTranslation();
    return (
        <div
            className="available-prices-selector"
            data-numoptions={priceTiers.length}
            data-selectedoption={selectedIndex}
            data-disabled="false"
        >
            <ButtonGroup size="lg" boldSublabel={true}>
                {priceTiers.map(priceTier => {
                    return (
                        <GroupButton
                            key={serializePriceTier(priceTier)}
                            label={priceTier.lendingModel!}
                            subLabel={t(`shop.priceTier.${getPriceTierLevelLabel(priceTier, t)}`, {
                                defaultValue: getPriceTierLevelLabel(priceTier, t)
                            })}
                            state={comparePriceTier(priceTier, value) ? 'not-clickable' : 'disabled'}
                        />
                    );
                })}
            </ButtonGroup>

            <div className="selected-flags">
                {priceTiers.map(priceTier => {
                    const key = serializePriceTier(priceTier);
                    return comparePriceTier(priceTier, value) ? (
                        /* TODO [i18n] css Increase size of selected button */
                        <div key={key}>{t('selected')}</div>
                    ) : (
                        <div key={key} className="select" onClick={() => onChange(priceTier)}>
                            {t('select')}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
